module.exports = __webpack_public_path__ + "static/media/funnel_effect.0cb83729.png";